import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useAuth } from './contexts/AuthContext';

const ExchangeRateContext = createContext({ rate: 0, date: '' }); // default fallback

export function ExchangeRateProvider({ children }) {
  const [exchangeData, setExchangeData] = useState({ rate: 0, date: '' });
  const { token, user } = useAuth();

  const fetchExchangeData = useCallback(async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...(user?.ownerId ? { 'x-owner-id': String(user.ownerId) } : {}),
        ...(user?.staffId ? { 'x-staff-id': String(user.staffId) } : {})
      };
      const res = await fetch('/api/exchange-rates', { headers });
      if (!res.ok) throw new Error('Failed to fetch');
      const data = await res.json();
      if (data.rate && data.date) {
        setExchangeData({ rate: data.rate, date: data.date });
      }
    } catch (e) {
      // fallback: keep previous data
    }
  }, [token, user?.ownerId, user?.staffId]);

  useEffect(() => {
    let isMounted = true;
    const run = async () => {
      if (!isMounted) return;
      await fetchExchangeData();
    };
    run();
    const interval = setInterval(run, 60 * 60 * 1000); // refresh every hour
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [fetchExchangeData]);

  return (
    <ExchangeRateContext.Provider value={{ ...exchangeData, refresh: fetchExchangeData }}>
      {children}
    </ExchangeRateContext.Provider>
  );
}

export function useExchangeRate() {
  return useContext(ExchangeRateContext);
}